import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import useStyles from './styles';
import { useStore } from 'src/stores';
import { observer } from 'mobx-react-lite';
import { parseJwt } from 'src/core/services/jwt';
import React, { useEffect, useState } from 'react';
import { Logo } from '@livable/saas-react-components';
import { AUTH_TOKEN_KEYS } from 'src/constants/authToken';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, LinearProgress, Typography } from '@mui/material';
export const CompanyRedirectPage = observer(() => {
  var _newCompanyData$name, _newCompanyData$name2;
  const store = useStore();
  const classes = useStyles();
  const navigate = useNavigate();
  const _useParams = useParams(),
    companyId = _useParams.companyId;
  const params = new URLSearchParams(window.location.search);
  const redirectedFrom = params.get('redirectedFrom');
  const _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    currentCompanyData = _useState2[0],
    setCurrentCompanyData = _useState2[1];
  const _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    newCompanyData = _useState4[0],
    setNewCompanyData = _useState4[1];
  const _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isLoading = _useState6[0],
    setIsLoading = _useState6[1];
  const getDetails = async () => {
    const accessTokenAsync = parseJwt(localStorage.getItem(AUTH_TOKEN_KEYS.accessToken));
    const currentResp = await store.admin.getCompanyByIdAsync.run(accessTokenAsync['custom:companyid']);
    setCurrentCompanyData(currentResp === null || currentResp === void 0 ? void 0 : currentResp.response);
    const newResp = await store.admin.getCompanyByIdAsync.run(companyId);
    if (newResp !== null && newResp !== void 0 && newResp.response) {
      setNewCompanyData(newResp === null || newResp === void 0 ? void 0 : newResp.response);
    } else {
      navigate("/active_dashboard/".concat(accessTokenAsync['custom:companyid'], "/all/all"), {
        replace: true
      });
    }
  };
  const loginToNewCompany = async () => {
    try {
      setIsLoading(true);
      await store.admin.getAdminAccountLoginImpersonateAsync.run({
        companyId: newCompanyData === null || newCompanyData === void 0 ? void 0 : newCompanyData.id
      });
      await store.account.refreshAccessTokenAsync.run();
      await store.portfolios.getExistingPortfoliosAsync.run();
      await store.company.getCompaniesAsync.run();
      store.admin.saveSelectedCompanyName(newCompanyData === null || newCompanyData === void 0 ? void 0 : newCompanyData.name);
      navigate(redirectedFrom || "/active_dashboard/".concat(newCompanyData === null || newCompanyData === void 0 ? void 0 : newCompanyData.id, "/all/all"), {
        replace: true
      });
      window.location.reload();
      setIsLoading(false);
    } catch (currentError) {
      console.log('Error', currentError);
      setIsLoading(false);
    }
  };
  useEffect(() => {
    getDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.wrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.logo
  }, /*#__PURE__*/React.createElement(Logo, null)), /*#__PURE__*/React.createElement("div", {
    className: classes.message
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h3",
    className: classes.header
  }, "You are logged in to the company \u201C", currentCompanyData === null || currentCompanyData === void 0 ? void 0 : currentCompanyData.name, "\u201D and want to follow a link that belongs to the company \u201C", (_newCompanyData$name = newCompanyData === null || newCompanyData === void 0 ? void 0 : newCompanyData.name) !== null && _newCompanyData$name !== void 0 ? _newCompanyData$name : 'N/A', ".\u201D To do this, we must switch to the company \u201C", (_newCompanyData$name2 = newCompanyData === null || newCompanyData === void 0 ? void 0 : newCompanyData.name) !== null && _newCompanyData$name2 !== void 0 ? _newCompanyData$name2 : 'N/A', ".\u201D Do you agree?")), /*#__PURE__*/React.createElement("div", {
    className: classes.actions
  }, isLoading && /*#__PURE__*/React.createElement(LinearProgress, null), !isLoading && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    onClick: () => loginToNewCompany()
  }, "Yes"), /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    onClick: () => navigate('/active_dashboard')
  }, "No"))));
});